import { FC, useState } from "react"
import game1 from 'assets/images/game-1.jpg'
import game2 from 'assets/images/game-2.jpg'
import game3 from 'assets/images/game-3.png'

const SectionGames: FC<{iframe?: boolean}> = ({iframe = false}) => {

  const [gameUrl, setGameUrl] = useState(null)
  
  const urls = [
    {image: game1, url: 'https://www.educaplay.com/game/21387319-loje_pershtatjeje_numrash_dhe_bletesh.html'},
    {image: game2, url: 'https://www.educaplay.com/game/21397150-animal_bingo_albanian.html'},
    {image: game3, url: 'https://game.esybee.com/'}
  ]

  return (
      <>
       {!gameUrl &&
        <div style={{ display: 'flex', gap: '20px'}}>
            {urls.map((g, idx) => <div key={idx} style={{ width: '300px', maxWidth: '40vw'}}>
                <div className='box-shadow'
                    onClick={() => {
                        if(iframe)
                          setGameUrl(g.url)
                        else
                          window.open(g.url, '_blank', 'rel=noopener noreferrer')
                    }}

                    style={{
                        cursor: 'zoom-in',
                        aspectRatio: 1.5,
                        backgroundColor: '#fff',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        backgroundPosition: 'center center',
                        backgroundImage: `url('${g.image}')`
                    }}></div>
            </div>)}   
        </div>}


         {gameUrl &&
            <div style={{ display: 'flex', justifyContent: 'center' }}><iframe allow="fullscreen; autoplay;"  
                style={{ margin: 'auto', width: 'calc((100vh - 90px)*1.77)', height: 'calc(100vh - 90px)' }}
                allowFullScreen 
                src={gameUrl}></iframe></div>
         }
    </>
  )
}

export default SectionGames
